import { GroupSharingT, UserSharingT } from 'business/definitions';
import {
    IconButton,
    List,
    ListItem,
    ListItemText,
    Switch,
    TableCell,
    TableRow,
    Typography,
    styled,
} from '@mui/material';
import React, { ChangeEvent, useState } from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import Flex from 'ui/Flex/Flex';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PeopleIcon from '@mui/icons-material/People';
import { isUserSharing } from '../helpers';
import useGetUserGroup from 'hooks/userGroups/useGetUserGroup';

const StyListItem = styled(ListItem, {
    name: 'StyListItem',
})(({ theme }) => ({
    paddingBottom: theme.spacing(0.25),
    paddingTop: theme.spacing(0.25),
}));

const GroupMembersList = ({ groupSharingId }: { groupSharingId: number }) => {
    const { data: userGroup } = useGetUserGroup(groupSharingId);
    if (!userGroup) return <></>;

    return (
        <List>
            {userGroup.users.map((user) => (
                <StyListItem key={user.email}>
                    <ListItemText
                        primary={
                            <Typography variant="body2">
                                {user.email}
                            </Typography>
                        }
                    />
                </StyListItem>
            ))}
        </List>
    );
};

type SelectedSharingOptionProps = {
    disabled: boolean;
    share: UserSharingT | GroupSharingT;
    onDeleteClick: () => void;
    handleSwitchChange: (event: ChangeEvent<HTMLInputElement>) => void;
};
const SelectedSharingOption = ({
    disabled,
    share,
    onDeleteClick,
    handleSwitchChange,
}: SelectedSharingOptionProps) => {
    const [isOptionExtended, setIsOptionExtended] = useState(false);

    return (
        <>
            <TableRow key={share.key} data-testid={`share-${share.key}`}>
                <TableCell>
                    {isUserSharing(share) ? (
                        share.email
                    ) : (
                        <Flex alignItems="center" gap={2}>
                            <PeopleIcon />
                            <span>{`${share.groupName} (${share.nbMembers})`}</span>
                            <IconButton
                                aria-label="show group members"
                                size="small"
                                onClick={() =>
                                    setIsOptionExtended(!isOptionExtended)
                                }
                            >
                                {isOptionExtended ? (
                                    <KeyboardArrowUpIcon />
                                ) : (
                                    <KeyboardArrowDownIcon />
                                )}
                            </IconButton>
                        </Flex>
                    )}
                </TableCell>
                <TableCell>
                    <Switch
                        data-testid={`share-editaccess-${share.key}`}
                        disabled={disabled}
                        color="primary"
                        checked={share.editAccess}
                        onChange={handleSwitchChange}
                    />
                </TableCell>
                <TableCell size="small">
                    <IconButton
                        data-testid={`remove-share-${share.key}`}
                        disabled={disabled}
                        onClick={onDeleteClick}
                    >
                        <CancelIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
            {isOptionExtended && !isUserSharing(share) && (
                <TableRow>
                    <TableCell>
                        <GroupMembersList groupSharingId={share.groupId} />
                    </TableCell>
                </TableRow>
            )}
        </>
    );
};

export default SelectedSharingOption;
